import styled, { css } from 'styled-components';
import FestiveImage from '../../assets/img/wom2.png';
import TranquilImage from '../../assets/img/wom.png';
import FamilyImage from '../../assets/img/family.png';

export const RecommendationSection = styled.section`
  margin-bottom: 40px;
  padding: 0 10px;

  @media(min-width: 768px) {
    margin-bottom: 45px;
    padding: 0 40px;
  }

  @media(min-width: 1024px) {
    padding: 0;
  }
`;

export const RecommendationContainer = styled.div`
  padding: 15px 10px;

  border: 4px solid ${({ theme }) => theme.blue};

  @media(min-width: 768px) {
    position: relative;

    max-width: 750px;
    min-height: 505px;
    margin: 0 auto;
    padding: 45px;
    padding-right: 275px;
    padding-bottom: 35px;

    &::before {
      content: "";

      position: absolute;
      bottom: 0;
      background: transparent no-repeat center / contain;

      // Festive
      ${props => props.hotelType === 0 && css`
        background-image: url('${FestiveImage}');
        width: 438px;
        height: 438px;
        right: -50px;
      `};

      // Tranquil
      ${props => props.hotelType === 1 && css`
        background-image: url('${TranquilImage}');
        width: 490px;
        height: 598px;
        right: -160px;
      `};

      // Family
      ${props => props.hotelType === 2 && css`
        background-image: url('${FamilyImage}');
        width: 436px;
        height: 469px;
        right: -140px;
      `};

    }
  }

  @media(min-width: 1024px) {
    max-width: none;

    padding-right: 335px;

    &::before {

      // Tranquil
      ${props => props.hotelType === 1 && css`
        right: -120px;
      `};

      // Family
      ${props => props.hotelType === 2 && css`
        right: -95px;
      `};

    }
  }
`;

export const RecommendationHeading = styled.h2`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;

  font-size: 18px;
  line-height: 1;

  @media(min-width: 768px) {
    font-size: 24px;
  }
`;

export const RecommendationDescription = styled.p`
  margin: 0;
  padding: 0;

  font-size: 12px;
  line-height: 16px;

  @media(min-width: 768px) {
    font-size: 16px;
    line-height: 22px;
  }
`;
